import Heart from '../Heart';
import styles from './ProductCard.module.css';

const ProductCard = ({ productName, productImage, imageWidth = '135px' }) => {
  return (
    <div className={`rounded-md border border-cardBorder relative px-3 py-6 cursor-pointer ${styles.productCard}`}>
      <div className="absolute top-3 right-4 cursor-pointer"><Heart /></div>
      <div className="flex flex-col items-center justify-center gap-3 h-full">
        <img width={imageWidth} className={styles.image} src={productImage} alt={productName} />
        <p className="uppercase">{productName}</p>
      </div>
    </div>
  );
}

export { ProductCard };